import { Typography,Button, CircularProgress } from '@mui/material';
import React from 'react';
import API from '../API';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';
export default class DriverAnnouncementsScreen extends React.Component {

    constructor() {
        super();


       
        this.state = {replies: [], data: "", loading: true, announcements: []};
    }

    componentDidMount() {
        API.fetch("getannouncements").then(announcements => {
            this.setState({loading: false, announcements})
        })
    }

    move(index, direction) {
        const announcements = [...this.state.announcements];
        const next = index + direction;
        if (next < 0 || next >= announcements.length) return;
        [announcements[index], announcements[next]] = [announcements[next], announcements[index]];
        API.fetch("saveannouncement", {orderIds: announcements.map((item) => item._id)}).then((result) => {
            if (result?.ok) this.setState({announcements});
        });
    }

    componentWillUnmount() {
       
    }

    
    render() {

        if(this.state.loading) return <div><CircularProgress /></div>
        return <div style={{display:"flex", flexDirection:"column", gap: 20}}>

            <Typography style={{marginBottom: 20}} variant='h5'>Sürücü Duyuruları</Typography>

            {this.state.announcements.map((x, indx) => <div style={{backgroundColor:"white", padding:20, borderRadius:10, display:"flex", justifyContent:"space-between", alignItems:"center"}} key={x._id}>

                <div>

                    <Typography variant='h6'>{x.title}</Typography>
                    <Typography>{x.preview}</Typography>
                    <Typography variant="caption">{x.cities?.length ? `${x.cities.length} şehir` : "Tüm şehirler"} · {x.vehicleTypes?.length ? `${x.vehicleTypes.length} araç tipi` : "Tüm araçlar"}</Typography>
                </div>

                <div>
                    <Button disabled={indx === 0} onClick={() => this.move(indx, -1)}>↑</Button>
                    <Button disabled={indx === this.state.announcements.length - 1} onClick={() => this.move(indx, 1)}>↓</Button>
                    <Link to={'../driverannouncements/' + x._id}><Button><ArrowForwardIcon /></Button></Link>
                </div>

            </div>)}

            <Link to="../driverannouncements/new"><Button>Yeni</Button></Link>
           
        </div>
    }
}
